<template>
  <van-tabbar id="footer" v-model="activeValue" @change="navChange">
    <van-tabbar-item icon="shop">首页</van-tabbar-item>
    <van-tabbar-item class="rob-bright">
      <span>抢券</span>
      <template #icon="props">
        <img
          v-if="activeValue !== 1"
          src="../../../../assets/enterprise/coupons/rob.png"
          alt=""
        />
        <img
          class="bright"
          v-else
          src="../../../../assets/enterprise/coupons/rob-bright.png"
          alt=""
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item icon="coupon-o">用券</van-tabbar-item>
  </van-tabbar>
</template>
<script>
import MSG from './msg'
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { Toast } from 'vant'
import { findCurrentTime } from '@api/coupons/index'
export default {
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeValue: 0,
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      distribute: {},
      flag: 1
    }
  },
  watch: {
    active(val) {
      this.activeValue = val
    },
    activeValue(old, val) {
      if (old === 1) {
        if (this.distribute) {
          this.loveTime(this.distribute, old, val)
        } else {
          Toast('服务券还未开始发放')
          this.activeValue = val
          return
        }
      } else {
        this.$emit('update:active', old)
      }
    }
  },
  mounted() {
    // this.loveTime(this.distribute)
    const that = this
    MSG.$on('val', function(val) {
      that.distribute = val
    })
    MSG.$on('dateUp', function(val) {
      that.activeValue = val
    })
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },

    // 时间倒计时
    loveTime(timeList, old, val) {
      findCurrentTime().then(res => {
        if (res.data.code == '0000') {
          this.time1 = res.data.data
          var the = new Date(timeList.replace(/-/g, '/')).getTime()
          var date = this.time1
          var time = (the - date) / 1000
          var d = parseInt(time / (60 * 60 * 24))
          this.flag = d
          if (this.flag < 1) {
            this.buriedPoint()
            this.$emit('update:active', old)
          } else {
            Toast('未到抢券时间')
            this.activeValue = val
            return
          }
        }
      })
    },
    navChange(e) {
      if (e == 2) {
        this.buriedPoint()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  box-shadow: 0 0 6px #eee;
  position: fixed;
  bottom: -1px;
  z-index: 100;
  background: #fff;
}
.rob-bright {
  position: relative;
  /deep/.van-tabbar-item__icon {
    img {
      position: absolute;
      top: -42px;
      left: -28px;
      z-index: 10;
      width: 53px;
      height: 53px;
      border-radius: 50%;
      border: 4px solid #0077cc;
    }
    .bright {
      border: 4px solid #f3f8ff;
    }
  }
  /deep/.van-tabbar-item__text {
    margin-top: 22px;
  }
}
</style>
